module.exports = __webpack_public_path__ + "50d0d2c8b1aaca43466c1029bc66e7a5.MP3";